export default __webpack_public_path__ + "static/media/Graphic-Assets3.73b354a6.jpg";